import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import dailymetalrateService from "./dailymetalrateService";

// export const getAllRates = createAsyncThunk(
//   "rate/latest-rates",
//   async (thunkAPI) => {
//     try {
//       return await dailymetalrateService.getAllRates();
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error);
//     }
//   }
// );

export const getAllRates = createAsyncThunk(
  "rate/latest-rates",
  async (_, thunkAPI) => {
    try {
      const response = await dailymetalrateService.getAllRates();
      console.log("API Response:", response); // Debugging line
      return response;
    } catch (error) {
      console.error("API Error:", error); // Debugging line
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);


export const deleteAEnquiry = createAsyncThunk(
  "enquiry/delete-enquiry",
  async (id, thunkAPI) => {
    try {
      return await dailymetalrateService.deleteEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAEnquiry = createAsyncThunk(
  "contactus/get",
  async (id, thunkAPI) => {
    try {
      return await dailymetalrateService.getEnquiry(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

// export const updateMetalRates = createAsyncThunk(
//   "rate/update-rates",
//   async (rates, thunkAPI) => {
//     try {
//       return await dailymetalrateService.updateRates(rates);
//     } catch (error) {
//       return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
//     }
//   }
// );

export const updateRates = createAsyncThunk(
  "rate/update-rates",
  async (rates, thunkAPI) => {
    try {
      const response = await dailymetalrateService.updateRates(rates);
      console.log("Update Rates Response:", response); // Debugging line
      return response;
    } catch (error) {
      console.error("Update Rates Error:", error); // Debugging line
      return thunkAPI.rejectWithValue(error.response?.data || "Unknown error");
    }
  }
);

export const resetState = createAction("Reset_all");

const initialState = {
  metalRates: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};
export const dailymetalrateSlice = createSlice({
  name: "metalRates",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getAllRates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllRates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.metalRates = action.payload.data;
      })
      .addCase(getAllRates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedEnquiry = action.payload;
      })
      .addCase(deleteAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getAEnquiry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAEnquiry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.enqName = action.payload.name;
        state.enqMobile = action.payload.mobile;
        state.enqEmail = action.payload.email;
        state.enqComment = action.payload.message;
        state.enqStatus = action.payload.status;
      })
      .addCase(getAEnquiry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateRates.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateRates.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        // state.metalRates = {
        //   ...state.metalRates,
        //   ...action.payload, // Merge new values with previous ones
        // };
        state.metalRates = action.payload.data;
      })
      .addCase(updateRates.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});
export default dailymetalrateSlice.reducer;
